import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { validateActiveSession } from '../utils/session.js';

export default function RequireAuth({ children }) {
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    let cancelled = false;
    validateActiveSession()
      .then((session) => {
        if (!cancelled) setStatus(session ? 'valid' : 'invalid');
      })
      .catch(() => {
        if (!cancelled) setStatus('invalid');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (status === 'checking') {
    return <div className="content-page">Checking session...</div>;
  }

  if (status === 'invalid') return <Navigate to="/login" replace />;
  return children;
}
